import JsonSerializer from "~/serializers/json_serializer"
import { Serializer } from "~/types/serializer"
import { Optional } from "~/types/types.util"

interface Options<T> {
  serializer?: Serializer<T>
}

export function deserializeFromLocalStorage<T>(
  key: string, { serializer }: Options<T> = {},
): Optional<T> {
  const activeSerializer = serializer ?? new JsonSerializer()
  const item = localStorage.getItem(key)

  // We catch the error so that invalid JSON in cache doesn't crash the app
  try {
    return item != null ? activeSerializer.deserialize(item) : null
  } catch (error) {
    console.error(error)
  }
}

export function serializeToLocalStorage<T>(
  key: string, newValue: T, { serializer }: Options<T> = {},
): void {
  const activeSerializer = serializer ?? new JsonSerializer()
  localStorage.setItem(key, activeSerializer.serialize(newValue))
}
